import React from 'react'

const Notfound = () => {
    return(
    <header>
        <h1>Not found</h1>
    </header>
    );
}

export default Notfound
